import './styles.scss';

export default {
  name: 'ForgotPasswordEmail',

  data() {
    return {
      email: '',
      allowLogin: true
    }
  },


  methods: {
    async authenticate() {
      if (this.email) {
        if (this.$store.state.online_status) {

          this.loginAlert = await this.$ionic.loadingController.create({
            spinner: 'lines',
            animated: true,
            message: '',
            translucent: false,
          });

          this.loginAlert.present();

          const data = {
            email: this.email
          };

          this.$store
            .dispatch("checkEmail", data)
            .then((response) => {
              this.loginAlert.dismiss();
              this.$router.push({
                path: '/forgot-password/forgot-password-question',
                query: {
                  email: this.email,
                  question: response.SecurityQuestion,
                  questionId: response.SecurityQuestionId
                }
              });
            })
            .catch((error) => {
              this.loginAlert.dismiss();
              this.$ionic.alertController
                .create({
                  message: error,
                  buttons: ["OK"],
                })
                .then((a) => a.present());
            });
        } else {
          this.$ionic.alertController
            .create({
              message: "Please establish and internet connection and try again.",
              buttons: ["OK"],
            })
            .then((a) => a.present());
        }
      } else {
        let message = 'Please enter your email address.';

        this.$ionic.alertController.create({
          header: 'Error',
          message: message,
          buttons: ['OK'],
        }).then(a => a.present());
      }
    }
  }
};